import Vue from "vue";
import VueDrift from "vue-drift";

Vue.use(VueDrift, {
  appId: "gr2yviu2txvf"
});
